import { Variant } from "scmp-sdk/components/newsletter/newsletter-widget/enums";
import type { NewsletterItem } from "scmp-sdk/components/newsletter/types";
import type { TriggerPoint } from "scmp-sdk/lib/google-analytics/ga4-types";

export const getNewsletterTitle = (newsletterItem?: NewsletterItem) => newsletterItem?.name;

export const getTriggerPoint = (variant: Variant): TriggerPoint => {
  switch (variant) {
    case Variant.AcquisitionNewsletterPopup:
      return "ppto";
    case Variant.Article:
      return "article inline";
    case Variant.Article20:
    case Variant.ArticleDark:
    case Variant.LiveArticle:
      return "article_side";
    case Variant.Footer:
      return "footer inline";
    case Variant.Homepage:
      return "homepage inline";
    case Variant.NewsletterArticle:
    case Variant.NewsletterArticleBottom:
      return "newsletter article";
    case Variant.NewsletterList:
      return "newsletter index";
    case Variant.NewsletterPreview:
      return "newsletter preview";
    case Variant.Section:
      return "section inline";
  }
};
